import { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import PropTypes from "prop-types";

// Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled Components
const NavContainer = styled(Box)(({ theme, scrolled }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1100,
  padding: theme.spacing(1.5, 3),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: scrolled ? "rgba(255, 255, 255, 0.9)" : "rgba(255, 255, 255, 0.9)",
  backdropFilter: scrolled ? "blur(10px)" : "blur(5px)",
  borderBottom: `1px solid ${scrolled ? "rgba(0, 0, 0, 0.1)" : "transparent"}`,
  transform: `translateY(${scrolled ? "0" : "0"})`,
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  animation: `${fadeIn} 0.5s ease-out`,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1, 2),
  },
}));

const LogoWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: -8,
    left: "50%",
    width: 0,
    height: 2,
    backgroundColor: "#238856",
    transform: "translateX(-50%)",
    transition: "width 0.3s ease",
  },
  "&:hover::after": {
    width: "80%",
  },
}));

const Logo = styled("img")(({ theme }) => ({
  height: 50,
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
  [theme.breakpoints.down("sm")]: {
    height: 40,
  },
}));

const SignInButton = styled(Button)(({ theme }) => ({
  borderRadius: 28,
  padding: "10px 24px",
  color: "#238856 !important",
  textTransform: "none",
  fontSize: "0.95rem",
  fontWeight: 500,
  border: "2px solid #238856",
  backgroundColor: "transparent",
  transition: "all 0.3s ease",
  "&.focus": {
    color: "#238856 !important",
  },
  "&:hover": {
    transform: "translateY(-2px)",
    backgroundColor: "rgba(35, 136, 86, 0.04)",
    border: "2px solid #238856",
    color: "#238856 !important",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "8px 16px",
    fontSize: "0.85rem",
  },
}));

const CustomNavbar = ({ logoStatus, logoIdUrl, CateringReward, setAuthSection, setOpen }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    setOpen(true);
    setAuthSection("password");
  };

  return (
    <>
      <NavContainer scrolled={scrolled}>
        <LogoWrapper>
          <Logo
            src={logoStatus === 2 ? "" : logoStatus === 1 && logoIdUrl ? logoIdUrl : CateringReward}
            alt="Logo"
          />
        </LogoWrapper>

        <>
          <SignInButton onClick={handleClick}>Login</SignInButton>
        </>
      </NavContainer>

      {/* Spacer to prevent content from going under fixed navbar */}
      <Box sx={{ height: { xs: "64px", sm: "72px" } }} />
    </>
  );
};

export default CustomNavbar;

CustomNavbar.propTypes = {
  logoStatus: PropTypes.number.isRequired,
  logoIdUrl: PropTypes.string,
  CateringReward: PropTypes.string,
  setAuthSection: PropTypes.any,
  setOpen: PropTypes.any,
  children: PropTypes.node,
};
